export class CartItemRequest {
  productId: number;
  quantity: number;
  attributeValueIds: Array<number>;
  isFromOutOfCart: boolean;

  constructor(productId: number, quantity: number, attributeValueIds: Array<number>, isFromOutOfCart: boolean) {
    this.productId = productId;
    this.quantity = quantity;
    this.attributeValueIds = attributeValueIds;
    this.isFromOutOfCart = isFromOutOfCart;
  }
}
